<template>
  <div id="projectContent">
    <h3>{{ newTitle }}</h3>
    <div class="content"
         v-html="newHtml">
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {getNewInfo} from '../../api/news.js'

export default {
  data: () => ({
    index: 0,
    newHtml: '',
    newTitle: '',
  }),
  computed: {
    ...mapState([
      'TabIndex',
      'title'
    ])
  },
  watch: {
    TabIndex() {
      this.index = this.$route.query.index
      this.changeHtml()
    },
    // title(newTitle) {
    //   this.newTitle = newTitle
    //   this.changeHtml()
    // }
  },
  created() {
    this.newTitle = this.title
  },
  mounted() {
    this.index = this.$route.query.index
    this.changeHtml()
  },
  methods: {
    //获取详情
    async getInfo(id) {
      const res = await getNewInfo({id})
      this.newHtml = res.data.content
      this.newTitle = res.data.title
      console.log(res)
    },
    changeHtml() {
      if (this.index == 0) {
        this.getInfo(62)

        // this.newHtml = this.html1
      } else if (this.index == 1) {
        this.getInfo(64)
      } else if (this.index == 2) {
        this.getInfo(66)
      } else if (this.index == 3) {
        this.newHtml = '开发中。。'
        this.newTitle = '在线学习'
      } else if (this.index == 4) {
        this.getInfo(68)
      } else {
        this.newHtml = '开发中。。。'
        this.newTitle = '开发中。。。'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#projectContent {
  min-height: 626px;
  width: 100%;
  margin-top: 10px;
  border: 1px #2073dfb4 solid;

  h3 {
    margin: 30px 0;
    font-size: 20px;
    text-align: center;
  }
}

.content {
  padding: 20px;
  padding-top: 0;
}
</style>
